var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"currentRowTable",staticStyle:{"border":"1px solid #ff9900"},attrs:{"columns":_vm.columns3,"data":_vm.data1,"size":"small","show-header":_vm.headerShow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }